import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-w-[14rem] flex-1" }
const _hoisted_2 = { class: "text-[14.5px] font-bold leading-tight text-catering-ink-900" }
const _hoisted_3 = { class: "mt-0.5 text-[12.5px] leading-snug text-catering-ink-600" }
const _hoisted_4 = { class: "ml-auto flex flex-wrap items-center gap-3.5" }
const _hoisted_5 = {
  class: "setup-banner__meter",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "font-catering-mono text-[11px] text-catering-ink-500" }
const _hoisted_7 = ["href"]

import { computed } from 'vue'

import GlowFrame from '@/components/catering/GlowFrame.vue'
import SwooshArrow from '@/components/catering/SwooshArrow.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { neueButtonClasses } from '@/components/neue/neueButtonClasses'
import { setupBannerCopy } from '@/components/setup/setupSurfaceCopy'
import { useSetupSurface } from '@/components/setup/useSetupSurface'
import { useStorefrontLink } from '@/components/setup/useStorefrontLink'


export default {
  __name: 'SetupBanner',
  setup(__props) {

const { visible, progress, surface, open } = useSetupSurface()
const { url, canCopy, copied, copy: copyLink } = useStorefrontLink()

const copy = computed(() => setupBannerCopy(surface.value))

const SURFACE_CLASSES = {
  live: 'border-catering-herb-500/40 bg-gradient-to-b from-catering-herb-100 to-catering-cream-100',
  review: 'border-catering-honey-500/40 bg-gradient-to-b from-catering-honey-100 to-catering-cream-100'
}

const surfaceClass = computed(
  () =>
    SURFACE_CLASSES[copy.value.tone] ||
    'border-catering-cream-500 bg-gradient-to-b from-catering-lemon-100 to-catering-cream-200'
)

// The review dot does not pulse: pulsing is how this banner asks for a click, and
// there is nothing here to click.
const dotClass = computed(
  () =>
    ({
      live: 'setup-banner__dot--live bg-catering-herb-500',
      review: 'bg-catering-honey-500',
      blocked: 'setup-banner__dot--pulse bg-catering-honey-500',
      pending: 'setup-banner__dot--pulse bg-catering-honey-500',
      progress: 'setup-banner__dot--pulse bg-catering-lemon-600'
    })[copy.value.tone]
)

return (_ctx, _cache) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex flex-wrap items-center gap-x-4 gap-y-3 rounded-catering-md border px-4 py-3.5 font-catering-body", surfaceClass.value]),
        role: "status"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["setup-banner__dot", dotClass.value]),
          "aria-hidden": "true"
        }, null, 2),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(copy.value.title), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(copy.value.body), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["setup-banner__fill", _unref(surface).complete ? 'bg-catering-herb-500' : 'bg-catering-ink-900']),
              style: _normalizeStyle({ width: `${_unref(progress).percent}%` })
            }, null, 6)
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(progress).label), 1),
          (copy.value.action.kind === 'open')
            ? (_openBlock(), _createBlock(GlowFrame, {
                key: 0,
                subtle: "",
                "frame-class": "inline-flex rounded-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(NeueButton, {
                    type: "accent",
                    size: "sm",
                    onClick: _unref(open)
                  }, {
                    "icon-right": _withCtx(() => [
                      _createVNode(SwooshArrow, { class: "ml-0.5" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(copy.value.action.label) + " ", 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : (_unref(canCopy))
              ? (_openBlock(), _createBlock(NeueButton, {
                  key: 1,
                  type: "cream",
                  size: "sm",
                  onClick: _unref(copyLink)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(copied) ? 'Copied' : copy.value.action.label), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_unref(url))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: _unref(url),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: _normalizeClass(_unref(neueButtonClasses)({ type: 'cream', size: 'sm' }))
                  }, " Preview your storefront ", 10, _hoisted_7))
                : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

}